import severUrl from "../../api";
import axios from "axios";

export const addTodo = (payload) => ({ type: 'ADD_TODO', payload: payload });

export const listTodo = () => (dispatch) => {
   fetch(severUrl + `blog/list/current/`, {method: "POST"})
    .then((response) => response.json())
    .then((data) => dispatch({ type: 'LIST_TODO', payload: data.data }));
    //dispatch({ type: 'LIST_TODO', payload: data }); 
};

export const listPost = (currentPage, numberPerPage) => (dispatch) => {

     var bodyFormData = new FormData();
     bodyFormData.append("currentPage", currentPage + 1);
     bodyFormData.append("numberPerPage", numberPerPage);
   
     axios.post(severUrl + "blog/list/current/", bodyFormData).then((response) => response.data)
     .then((data) => {
        dispatch({ type: 'LIST_TODO', payload: data.data })
     })
 };


export const addPostList = (payload) => (dispatch) => {dispatch({ type: 'LIST_TODO', payload: payload })};
